'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'spinner';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f110';
var svgPathData = ['M16 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM86.3 86.3a32 32 0 1 0 45.3 45.3 32 32 0 1 0 -45.3-45.3zM224 48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z', 'M256 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm368-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM86.3 425.7a32 32 0 1 1 45.3-45.3 32 32 0 1 1 -45.3 45.3zm56.6-56.6A48 48 0 1 0 75 437 48 48 0 1 0 142.9 369.1zM131.5 86.3a32 32 0 1 1 -45.3 45.3 32 32 0 1 1 45.3-45.3zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9zM380.5 380.5a32 32 0 1 1 45.3 45.3 32 32 0 1 1 -45.3-45.3zM437 437A48 48 0 1 0 369.1 369.1 48 48 0 1 0 437 437z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpinner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;